<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="标题" prop="title">
                <Input v-model="formValidate.title" placeholder="请输入标题"></Input>
              </FormItem>
              <FormItem label="作者" prop="author">
                <Input v-model="formValidate.author" placeholder="请输入作者"></Input>
              </FormItem>
              <FormItem label="来源" prop="sources">
                <Input v-model="formValidate.sources" placeholder="请输入来源"></Input>
              </FormItem>
              <FormItem label="栏目" prop="column">
                <Select v-model="formValidate.column" placeholder="请选择栏目" @on-change="selectChange">
                  <Option v-for="(columnItem, index) in newsContent.columns" :key="index" :value="index">{{columnItem}}</Option>
                </Select>
              </FormItem>
              <FormItem label="摘要" prop="abstractTxt">
                <Input v-model="formValidate.abstractTxt" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入摘要..."></Input>
              </FormItem>
              <FormItem label="内容" prop="content">
                <ckeditor v-model="formValidate.content" :config="editorConfig"></ckeditor>
              </FormItem>
              <FormItem label="封面">
                <img :src="coverPic" class="cover-pic">
                <Upload
                 :action="GLOBAL_API.apiUrl + '/uploads/picture-for-news'"
                 :headers='{"Authorization": "Bearer " + token}'
                 :on-success="uploaded"
                >
                  <Button icon="ios-cloud-upload-outline">上传封面</Button>
                </Upload>
              </FormItem>
              <FormItem label="视频">
                <Input v-model="formValidate.video" placeholder="请输入视频播放地址，可以不填..."></Input>
              </FormItem>
              
              <FormItem>
                  <Button type="primary" @click="handleSubmit('formValidate')">保存修改</Button>
              </FormItem>
            </Form>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
//图片长宽比例 8 5
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
import nopic from '@/assets/images/nopic.jpg'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader,
  },

  data () {
    return {
      // 文本编辑器配置
      editorConfig: {
        language: 'zh-cn',//中文包
        fileTools_requestHeaders: {
          "Authorization": ""
        },
        extraPlugins:['font', 'justify', 'colorbutton'],
        filebrowserImageUploadUrl: this.GLOBAL_API.apiUrl + '/uploads/picture-for-editor',
      },
      coverPic: nopic,
      token: '',
      newsContent: {},
      formValidate: {
        newsId: 0,
        title: '',
        author: '',
        sources: '',
        column: 0,
        columnName: '',
        abstractTxt: '',
        content: '',
        cover: nopic,
        video: '',
      },
      ruleValidate: {
        title: [
          { required: true, message: '请输入新闻标题', trigger: 'blur' }
        ],
        // author: [
        //   { required: true, message: '请输入新闻作者', trigger: 'blur' }
        // ],
        sources: [
          { required: true, message: '请输入来源', trigger: 'blur' }
        ],
        column: [
          { required: true, message: '请选择栏目', trigger: 'change' }
        ],
        abstractTxt: [
          { required: true, message: '请输入摘要', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入新闻内容', trigger: 'blur' },
          { type: 'string', min: 20, message: '内容不能少于20个字符', trigger: 'blur' }
        ]
      }
    }
  },

  //页面加载完成后执行
  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()

    //获取学生信息
    this.getNewsContent()
  },

  //页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
        this.editorConfig.fileTools_requestHeaders.Authorization = "Bearer " + admin.token
      }
    },

    //从服务端获取文字列表
    getNewsContent() {
      let vm = this
      let id = parseInt(vm.$route.params.id)
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/news/get-for-edit",
        {id: id, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.newsContent = info.data
        vm.formValidate.newsId = id
        vm.formValidate.title = vm.newsContent.title
        vm.formValidate.author = vm.newsContent.author
        vm.formValidate.sources = vm.newsContent.comeFrom
        vm.formValidate.column = vm.newsContent.columnId+""
        vm.formValidate.columnName = vm.newsContent.columnName
        vm.formValidate.abstractTxt = vm.newsContent.description
        vm.formValidate.content = vm.newsContent.body
        vm.formValidate.cover = vm.newsContent.cover!=null ? vm.newsContent.cover : ""
        vm.formValidate.video = vm.newsContent.video
        vm.coverPic =  vm.newsContent.cover!=null ? vm.newsContent.cover : vm.coverPic
        //console.log(vm.newsContent)
      }).catch(function(error) {
        console.log(error)
      });
    },

    //表单数据提交
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let vm = this
          //vm.formValidate.columnName = 
          axios.post(
            vm.GLOBAL_API.apiUrl + "/manage/news/save-for-edit",
            vm.formValidate,
            {
              headers: {
                'content-type': 'application/json',
                "Authorization": "Bearer " + vm.token
              }
            }
          ).then(function(res) {
            let info = res.data
            let error = parseInt(info.code)
            if(error==0) {
              vm.$Message.success({
                  content: info.message,
                  duration: 3,
                  closable: true,
                  onClose:function() {
                    window.close()
                  }
              });
            } else {
              vm.$Message.error(info.message);
            }
          }).catch(function(error) {
            console.log(error)
          });
        } else {
          this.$Message.error('Fail!');
        }
      })
    },

    //文件上传成功
    uploaded (response) {
      let code = parseInt(response.uploaded)
      if(!isNaN(code) && code==1) {
        this.formValidate.cover = response.url
        this.coverPic =  response.url
      }
    },

    //栏目选择
    selectChange (value) {
      this.formValidate.column = value
      this.formValidate.columnName = this.newsContent.columns[value]
    }

  }
}
</script>